import React, {useEffect} from 'react';
import { BaseInput } from './BaseInput';
import { Input, StyledColorInput } from './styles';

export function ColorInput({
  label = 'Label',
  renderBottomElement,
  placeholder = '',
  onChangeColor = () => {},
  color = '',
  ...props
}) {

  return (
    <BaseInput
      fluid={false}
      minWidth="3rem"
      label={label}
      renderBottomElement={renderBottomElement}
      {...props}
    >
      <Input
        type="color"
        value={color}
        style={{ height: '2.5rem'}}
        onChange={(e) => onChangeColor(e.target.value)}
        {...props}
      />
    </BaseInput>
  )
}